/**
 * @file get the list of colors sorted
 * In the future we should add filters and reduce the useEffects loops
 */
import { useMemo } from 'react';

import { FiltersBySection } from '../enums';
import { ColorModel } from '../models';
import { sortColorsBy } from '../utils';

import { useAppSelector } from '~/redux/hooks';
import { selectUsableColors } from '~/redux/slices/color';
import { selectSortBy } from '~/redux/slices/sortAndFilter';

const colorFilterComponent = FiltersBySection.COLOR;

export const useColors = (): { colors: ColorModel[] } => {
  /**This selector is buggy and may return colors sorted or not. Here is used under the assumption that the sorting is not guaranteed */
  const colors = useAppSelector(selectUsableColors);
  const selectedSort = useAppSelector(selectSortBy(colorFilterComponent));

  const sortedColors = useMemo(
    () => sortColorsBy(selectedSort, colors),
    [selectedSort, colors]
  );

  return { colors: sortedColors };
};
